import { forwardRef, useEffect, useState } from 'react'

import {
    Radio,
    RadioGroup,
    Grid,
    FormControlLabel,
    FormControl,
    FormLabel,
    InputLabel,
    Input,
    TextField,
    Slide
} from '@mui/material';
import useHistorialClinico from '../../../hooks/useHistorialClinico';


const PatologicosD = () => {

    const { datosMedico, handleChangeClinico, handleChangeClinicoMed, historialAnio} = useHistorialClinico()
    // const { antecedentesPatologicos } = datosMedico
    const { antecedentesPatologicos } = historialAnio

    //Primera parte
    const [alergias, setAlergias] = useState(historialAnio.antecedentesPatologicos.antpaAlergiasPa==="Si"?true:false);
    const [asm, setAsm] = useState(historialAnio.antecedentesPatologicos.antpaAsmaPa==="Si"?true:false);
    const [can, setCan] = useState(historialAnio.antecedentesPatologicos.antpaCancerPa==="Si"?true:false);
    const [cirugias, setCirugias] = useState(historialAnio.antecedentesPatologicos.antpaCirugiasPa==="Si"?true:false)
    const [conv, setConv] = useState(historialAnio.antecedentesPatologicos.antpaConvulsionesPa==="Si"?true:false);
    const [desmayos, setDesmayos] = useState(historialAnio.antecedentesPatologicos.antpaDesmayosPa==="Si"?true:false);
    const [diab, setDiab] = useState(historialAnio.antecedentesPatologicos.antpaDiabetesPa==="Si"?true:false);
    const [dolores, setDolores] = useState(historialAnio.antecedentesPatologicos.antpaDolorEspaldaCuelloPa==="Si"?true:false);
    const [comunicacion, setComunicacion] = useState(historialAnio.antecedentesPatologicos.antpaLimitacionOralEscritaPa==="Si"?true:false);
    const [vision, setVision] = useState(historialAnio.antecedentesPatologicos.antpaDisminucionVisualPa==="Si"?true:false);
    const [audicion, setAudicion] = useState(historialAnio.antecedentesPatologicos.antpaDisminucionAudicionPa==="Si"?true:false);
    const [piel, setPiel] = useState(historialAnio.antecedentesPatologicos.antpaEnfPielPa==="Si"?true:false);
    const [pulmones, setPulmones] = useState(historialAnio.antecedentesPatologicos.antpaEnfPulmonesPa==="Si"?true:false);
    const [rin, setRin] = useState(historialAnio.antecedentesPatologicos.antpaEnfRinonesPa==="Si"?true:false);
    const [cor, setCor] = useState(historialAnio.antecedentesPatologicos.antpaEnfCorazonPa==="Si"?true:false);
    const [higado, setHigado] = useState(historialAnio.antecedentesPatologicos.antpaEnfHigadoPa==="Si"?true:false);
    const [fracturas, setFracturas] = useState(historialAnio.antecedentesPatologicos.antpaFracturasEsguincesAmputacionPa==="Si"?true:false);
    const [fuma, setFuma] = useState(historialAnio.antecedentesPatologicos.antpaFumaPa==="Si"?true:false);
    const [hip, setHip] = useState(historialAnio.antecedentesPatologicos.antpaHipertensionPa==="Si"?true:false);
    const [alcohol, setAlcohol] = useState(historialAnio.antecedentesPatologicos.antpaBebidasAlcoholicasPa==="Si"?true:false);
    const [varices, setVarices] = useState(historialAnio.antecedentesPatologicos.antpaVaricesPa==="Si"?true:false);

    //Segunda Parte
    const [sarampion, setSarampion] = useState(historialAnio.antecedentesPatologicos.antpaSarampionPa==="Si"?true:false);
    const [varicela, setVaricela] = useState(historialAnio.antecedentesPatologicos.antpaVaricelaPa==="Si"?true:false);
    const [rubeola, setRubeola] = useState(historialAnio.antecedentesPatologicos.antpaRubeolaPa==="Si"?true:false);
    const [herpes, setHerpes] = useState(historialAnio.antecedentesPatologicos.antpaHerpesPa==="Si"?true:false);
    const [paperas, setPaperas] = useState(historialAnio.antecedentesPatologicos.antpaParotiditisPa==="Si"?true:false);
    const [hepatitis, setHepatitis] = useState(historialAnio.antecedentesPatologicos.antpaHepatitisPa==="Si"?true:false);
    const [transfusiones, setTransfusiones] = useState(historialAnio.antecedentesPatologicos.antpaTransfusionesPa==="Si"?true:false);
    const [gastritis, setGastritis] = useState(historialAnio.antecedentesPatologicos.antpaGastritisPa==="Si"?true:false);
    const [colitis, setColitis] = useState(historialAnio.antecedentesPatologicos.antpaColitisPa==="Si"?true:false);
    const [hernias, setHernias] = useState(historialAnio.antecedentesPatologicos.antpaHerniasPa==="Si"?true:false);
    const [autoinmunes, setAutoinmunes] = useState(historialAnio.antecedentesPatologicos.antpaAutoinmunesPa==="Si"?true:false);
    const [movilidad, setMovilidad] = useState(historialAnio.antecedentesPatologicos.antpaLimitacionMovilidadPa==="Si"?true:false);
    const [nacimiento, setNacimiento] = useState(historialAnio.antecedentesPatologicos.antpaProblemasNacimientoPa==="Si"?true:false);
    const [medicamento, setMedicamento] = useState(historialAnio.antecedentesPatologicos.antpaConsumeMedicamentoPa==="Si"?true:false);
    const [depresion, setDepresion] = useState(historialAnio.antecedentesPatologicos.antpaDepresionAnsiedadPa==="Si"?true:false);
    const [terapia, setTerapia] = useState(historialAnio.antecedentesPatologicos.antpaTerapiaPa==="Si"?true:false);
    const [otras, setOtras] = useState(historialAnio.antecedentesPatologicos.antpaOtrasPa==="Si"?true:false);
    const [senas, setSenas] = useState(historialAnio.antecedentesPatologicos.antpaSeniasParticularesPa==="Si"?true:false);



    return (

        <Grid container spacing={1} p={1} style={{ backgroundColor:"#FFF" }}>
            {/*------------ Alergias --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Alergias</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaAlergiasPa"
                            value={historialAnio.antecedentesPatologicos.antpaAlergiasPa}
                            // onChange={(e) => { setAlergias(!alergias); handleChangeClinicoMed(e) }}
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {alergias ?
                    <Slide direction="left" in={alergias} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaAlergiasPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaAlergiasPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaAlergiasPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Asma --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Asma (silba el pecho)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaAsmaPa"
                            value={historialAnio.antecedentesPatologicos.antpaAsmaPa}
                            // onChange={(e) => { setAsm(!asm); handleChangeClinico(e) }}
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {asm ?
                    <Slide direction="left" in={asm} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="medicoTitulo"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaAsmaPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaAsmaPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Cancer --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Cáncer</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaCancerPa"
                            value={historialAnio.antecedentesPatologicos.antpaCancerPa}
                            onChange={(e) => { setCan(!can); handleChangeClinico(e)  }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {can ?
                    <Slide direction="left" in={can} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaCancerPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaCancerPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaCancerPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Cirugias --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Cirugías</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="historialAnio.antecedentesPatologicos,antpaCirugiasPa"
                            value={historialAnio.antecedentesPatologicos.antpaCancerPa}
                            onChange={(e) => { setCirugias(!cirugias); handleChangeClinico(e)  }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {cirugias ?
                    <Slide direction="left" in={cirugias} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaCirugiasPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaCirugiasPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaCirugiasPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Convulsiones --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Convulsiones</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaConvulsionesPa"
                            value={historialAnio.antecedentesPatologicos.antpaConvulsionesPa}
                            onChange={(e) => { setConv(!conv); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {conv ?
                    <Slide direction="left" in={conv} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaConvulsionesPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaConvulsionesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaConvulsionesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Desmayos --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Desmayos</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaDesmayosPa"
                            value={historialAnio.antecedentesPatologicos.antpaDesmayosPa}
                            onChange={(e) => { setDesmayos(!desmayos); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {desmayos ?
                    <Slide direction="left" in={desmayos} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaDesmayosPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaDesmayosPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaDesmayosPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Diabetes--------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Diabetes (azúcar elevada)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaDiabetesPa"
                            value={historialAnio.antecedentesPatologicos.antpaDiabetesPa}
                            onChange={(e) => { setDiab(!diab); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>

            <Grid item lg={7} sm={7} xs={12}>
                {diab ?
                    <Slide direction="left" in={diab} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaDiabetesPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaDiabetesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaDiabetesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Dolores --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}> Dolor constante de cuello o espalda baja</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaDolorEspaldaCuelloPa"
                            value={historialAnio.antecedentesPatologicos.antpaDolorEspaldaCuelloPa}
                            onChange={(e) => { setDolores(!dolores); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {dolores ?
                    <Slide direction="left" in={dolores} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaDolorEspaldaCuelloPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaDolorEspaldaCuelloPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaDolorEspaldaCuelloPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Comunicacion--------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Limitación en la comunicación oral y escrita</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaLimitacionOralEscritaPa"
                            value={historialAnio.antecedentesPatologicos.antpaLimitacionOralEscritaPa}
                            onChange={(e) => { setComunicacion(!comunicacion); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>

            <Grid item lg={7} sm={7} xs={12}>
                {comunicacion ?
                    <Slide direction="left" in={comunicacion} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaLimitacionOralEscritaPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaLimitacionOralEscritaPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaLimitacionOralEscritaPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Vision --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Disminución de la visión</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="historialAnio.antecedentesPatologicos,antpaDisminucionVisualPa"
                            value={historialAnio.antecedentesPatologicos.antpaDisminucionVisualPa}
                            onChange={(e) => { setVision(!vision); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {vision ?
                    <Slide direction="left" in={vision} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaDisminucionVisualPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaDisminucionVisualPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaDisminucionVisualPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Audicion --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Disminución en audición </FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="historialAnio.antecedentesPatologicos,antpaDisminucionAudicionPa"
                            value={historialAnio.antecedentesPatologicos.antpaDisminucionAudicionPa}
                            onChange={(e) => { setAudicion(!audicion); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {audicion ?
                    <Slide direction="left" in={audicion} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaDisminucionAudicionPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaDisminucionAudicionPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaDisminucionAudicionPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Piel --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Enfermedades De la piel</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                           name="historialAnio.antecedentesPatologicos,antpaEnfPielPa"
                            value={historialAnio.antecedentesPatologicos.antpaEnfPielPa}
                            onChange={(e) => { setPiel(!piel); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {piel ?
                    <Slide direction="left" in={piel} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaEnfPielPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaEnfPielPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaEnfPielPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Pulmones --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Enfermedades De los pulmones</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaEnfPulmonesPa"
                            value={historialAnio.antecedentesPatologicos.antpaEnfPulmonesPa}
                            // onChange={(e) => { setPulmones(!pulmones); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {pulmones ?
                    <Slide direction="left" in={pulmones} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaEnfPulmonesPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaEnfPulmonesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaEnfPulmonesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Riñon --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Enfermedades De los riñones</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaEnfRinonesPa"
                            value={historialAnio.antecedentesPatologicos.antpaEnfRinonesPa}
                            // onChange={(e) => { setRin(!rin); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {rin ?
                    <Slide direction="left" in={rin} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaEnfRinonesPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaEnfRinonesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaEnfRinonesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Corazon --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Enfermedades Del corazón</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                              name="historialAnio.antecedentesPatologicos,antpaEnfCorazonPa"
                            value={historialAnio.antecedentesPatologicos.antpaEnfCorazonPa}
                            // onChange={(e) => { setCor(!cor); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {cor ?
                    <Slide direction="left" in={cor} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaEnfCorazonPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaEnfCorazonPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaEnfCorazonPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Higado --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Enfermedades del hígado</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                           name="historialAnio.antecedentesPatologicos,antpaEnfHigadoPa"
                            value={historialAnio.antecedentesPatologicos.antpaEnfHigadoPa}
                            // onChange={(e) => { setHigado(!higado); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {higado ?
                    <Slide direction="left" in={higado} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaEnfHigadoPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaEnfHigadoPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaEnfHigadoPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Fracturas --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Fracturas, Esguinces o Amputación</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaFracturasEsguincesAmputacionPa"
                            value={historialAnio.antecedentesPatologicos.antpaFracturasEsguincesAmputacionPa}
                            // onChange={(e) => { setFracturas(!fracturas); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {fracturas ?
                    <Slide direction="left" in={fracturas} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaFracturasEsguincesAmputacionPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaFracturasEsguincesAmputacionPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaFracturasEsguincesAmputacionPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Fuma --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Fuma</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="historialAnio.antecedentesPatologicos,antpaFumaPa"
                            value={historialAnio.antecedentesPatologicos.antpaFumaPa}
                            // onChange={(e) => { setFuma(!fuma); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {fuma ?
                    <Slide direction="left" in={fuma} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaFumaPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaFumaPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaFumaPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Hipertensión (presión alta)--------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Hipertensión (presión alta)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaHipertensionPa"
                            value={historialAnio.antecedentesPatologicos.antpaHipertensionPa}
                            // onChange={(e) => { setHip(!hip); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {hip ?
                    <Slide direction="left" in={hip} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaHipertensionPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaHipertensionPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaHipertensionPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Toma --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Toma bebidas alcohólicas</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaBebidasAlcoholicasPa"
                            value={historialAnio.antecedentesPatologicos.antpaBebidasAlcoholicasPa}
                            // onChange={(e) => { setAlcohol(!alcohol); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {alcohol ?
                    <Slide direction="left" in={alcohol} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaBebidasAlcoholicasPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaBebidasAlcoholicasPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaBebidasAlcoholicasPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Varices --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Várices</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="historialAnio.antecedentesPatologicos,antpaVaricesPa"
                            value={historialAnio.antecedentesPatologicos.antpaVaricesPa}
                            // onChange={(e) => { setVarices(!varices); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {varices ?
                    <Slide direction="left" in={varices} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaVaricesPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaVaricesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaVaricesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Sarampion --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Sarampión</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="historialAnio.antecedentesPatologicos,antpaSarampionPa"
                            value={historialAnio.antecedentesPatologicos.antpaSarampionPa}
                            // onChange={(e) => { setSarampion(!sarampion); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {sarampion ?
                    <Slide direction="left" in={sarampion} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaSarampionPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaSarampionPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaSarampionPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Varicela --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Varicela</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaVaricelaPa"
                            value={historialAnio.antecedentesPatologicos.antpaVaricelaPa}
                            // onChange={(e) => { setVaricela(!varicela); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {varicela ?
                    <Slide direction="left" in={varicela} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaVaricelaPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaVaricelaPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaVaricelaPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Rubeola --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Rubeóla</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaRubeolaPa"
                            value={historialAnio.antecedentesPatologicos.antpaRubeolaPa}
                            // onChange={(e) => { setRubeola(!rubeola); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {rubeola ?
                    <Slide direction="left" in={rubeola} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaRubeolaPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaRubeolaPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaRubeolaPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Herpes --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Herpes</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="historialAnio.antecedentesPatologicos,antpaHerpesPa"
                            value={historialAnio.antecedentesPatologicos.antpaHerpesPa}
                            // onChange={(e) => { setHerpes(!herpes); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {herpes ?
                    <Slide direction="left" in={herpes} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaHerpesPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaHerpesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaHerpesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Paperas --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Parotiditis (paperas)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="historialAnio.antecedentesPatologicos,antpaParotiditisPa"
                            value={historialAnio.antecedentesPatologicos.antpaParotiditisPa}
                            // onChange={(e) => { setPaperas(!paperas); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {paperas ?
                    <Slide direction="left" in={paperas} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaParotiditisPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaParotiditisPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaParotiditisPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Hepatitis --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Hepatitis</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaHepatitisPa"
                            value={historialAnio.antecedentesPatologicos.antpaHepatitisPa}
                            // onChange={(e) => { setHepatitis(!hepatitis); handleChangeClinico(e)  }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {hepatitis ?
                    <Slide direction="left" in={hepatitis} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaHepatitisPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaHepatitisPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaHepatitisPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Transfusiones --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Transfusiones</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                             name="historialAnio.antecedentesPatologicos,antpaTransfusionesPa"
                            value={historialAnio.antecedentesPatologicos.antpaTransfusionesPa}
                            // onChange={(e) => { setTransfusiones(!transfusiones); handleChangeClinico(e)  }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {transfusiones ?
                    <Slide direction="left" in={transfusiones} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaTransfusionesPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaTransfusionesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaTransfusionesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Gastritis --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Gastritis</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaGastritisPa"
                            value={historialAnio.antecedentesPatologicos.antpaGastritisPa}
                            // onChange={(e) => { setGastritis(!gastritis) ; handleChangeClinico(e)}}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {gastritis ?
                    <Slide direction="left" in={gastritis} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaGastritisPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaGastritisPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaGastritisPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Colitis --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Colitis</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaColitisPa"
                            value={historialAnio.antecedentesPatologicos.antpaColitisPa}
                            // onChange={(e) => { setColitis(!colitis); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {colitis ?
                    <Slide direction="left" in={colitis} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaColitisPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaColitisPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaColitisPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------hernias --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Hernias</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaHerniasPa"
                            value={historialAnio.antecedentesPatologicos.antpaHerniasPa}
                            // onChange={(e) => { setHernias(!hernias); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {hernias ?
                    <Slide direction="left" in={hernias} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaHerniasPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaHerniasPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaHerniasPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>

            {/*------------ Auto --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Autoinmunes</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaAutoinmunesPa"
                            value={historialAnio.antecedentesPatologicos.antpaAutoinmunesPa}
                            // onChange={(e) => { setAutoinmunes(!autoinmunes); handleChangeClinico(e)  }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {autoinmunes ?
                    <Slide direction="left" in={autoinmunes} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaAutoinmunesPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaAutoinmunesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaAutoinmunesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Limitacion --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Limitación de movilidad </FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaLimitacionMovilidadPa"
                            value={historialAnio.antecedentesPatologicos.antpaLimitacionMovilidadPa}
                            // onChange={(e) => { setMovilidad(!movilidad); handleChangeClinico(e)  }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {movilidad ?
                    <Slide direction="left" in={movilidad} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaLimitacionMovilidadPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaLimitacionMovilidadPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaLimitacionMovilidadPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Problemas al nacimiento  --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Problemas al nacimiento  </FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaProblemasNacimientoPa"
                            value={historialAnio.antecedentesPatologicos.antpaProblemasNacimientoPa}
                            // onChange={(e) => { setNacimiento(!nacimiento); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {nacimiento ?
                    <Slide direction="left" in={nacimiento} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaProblemasNacimientoPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaProblemasNacimientoPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaProblemasNacimientoPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------medicamento  --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Consume algún medicamento</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                           name="historialAnio.antecedentesPatologicos,antpaConsumeMedicamentoPa"
                            value={historialAnio.antecedentesPatologicos.antpaConsumeMedicamentoPa}
                            // onChange={(e) => { setMedicamento(!medicamento) ; handleChangeClinico(e)}}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {medicamento ?
                    <Slide direction="left" in={medicamento} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaConsumeMedicamentoPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaConsumeMedicamentoPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaConsumeMedicamentoPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Depresion  --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Ha tenido depresión o ansiedad</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaDepresionAnsiedadPa"
                            value={historialAnio.antecedentesPatologicos.antpaDepresionAnsiedadPa}
                            // onChange={(e) => { setDepresion(!depresion); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {depresion ?
                    <Slide direction="left" in={depresion} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaDepresionAnsiedadPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaDepresionAnsiedadPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaDepresionAnsiedadPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Terapia  --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Ha recibido algún tipo de terapia</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaTerapiaPa"
                            value={historialAnio.antecedentesPatologicos.antpaTerapiaPa}
                            // onChange={(e) => { setTerapia(!terapia); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {terapia ?
                    <Slide direction="left" in={terapia} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaTerapiaPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaTerapiaPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaTerapiaPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
             {/*------------Otros  --------------- */}
             <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Otras</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="historialAnio.antecedentesPatologicos,antpaOtrasPa"
                            value={historialAnio.antecedentesPatologicos.antpaOtrasPa}
                            // onChange={(e) => { setOtras(!otras); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {otras ?
                    <Slide direction="left" in={otras} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaOtrasPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaOtrasPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaOtrasPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------Señas  --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="Senas" style={{ marginRight: "10px", width: "30%" }}>Señas particulares </FormLabel>
                        <span id="Senas" style={{ fontSize: "0.6em", fontStyle: "italic" }}> (tatuajes, perforaciones, cicatrices o marcas de nacimiento)</span>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="Senas"
                           name="historialAnio.antecedentesPatologicos,antpaSeniasParticularesPa"
                            value={historialAnio.antecedentesPatologicos.antpaSeniasParticularesPa}
                            // onChange={(e) => { setSenas(!senas); handleChangeClinico(e) }}
                            defaultValue="No"
                        >
                            <FormControlLabel disabled  value="No" control={<Radio />} label="No" />
                            <FormControlLabel disabled  value="Si" control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {senas ?
                    <Slide direction="left" in={senas} mountOnEnter unmountOnExit>
                        <TextField
                            disabled
                            fullWidth
                            id="antpaSeniasParticularesPaCom"
                            label="Comentarios (solo por médico)"
                            name="historialAnio.antecedentesPatologicos,antpaSeniasParticularesPaCom"
                            onChange={(e) => { handleChangeClinicoMed(e) }}
                            value={historialAnio.antecedentesPatologicos.antpaSeniasParticularesPaCom}
                            // value={pHijos}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
        </Grid>
    )
}

export default PatologicosD